import { render, staticRenderFns } from "./Regulator.vue?vue&type=template&id=b182ddc6&scoped=true&"
import script from "./Regulator.vue?vue&type=script&lang=js&"
export * from "./Regulator.vue?vue&type=script&lang=js&"
import style0 from "./Regulator.vue?vue&type=style&index=0&id=b182ddc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b182ddc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b182ddc6')) {
      api.createRecord('b182ddc6', component.options)
    } else {
      api.reload('b182ddc6', component.options)
    }
    module.hot.accept("./Regulator.vue?vue&type=template&id=b182ddc6&scoped=true&", function () {
      api.rerender('b182ddc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/operation/Regulator.vue"
export default component.exports